import { cardApi } from "@/core/data/api";

export default async (condition) => {
  return await cardApi.getCardListPagination(condition);
};
